import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListBook from "./ListBook";
import { UPADATE_STUDENT_BOOK } from "../../Schema/StudentBook";
import {
  SelectAcademicYear,
  SelectStudent,
  SelectEnrollByStudent,
  SelectWarehouse,
} from "../Include/DynamicSelect";

import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { GET_STUDENT_PAYMENT_PAGINATOR } from "../../Schema/StudentPayment";

export default function UpdateStudentBook({
  open,
  handleClose,
  setRefetch,
  dialogTitle,
  editData,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });
  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [enrollmentVal, setEnrollmentVal] = useState({
    id: "",
    title: "",
  });
  const [requiredField, setRequiredField] = useState(false);

  const book = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    sellQty: 0,
    key: Date.now() + Math.random(),
  };

  const [bookList, setBookList] = useState([book]);

  const handleAddListBook = () => {
    setBookList([...bookList, book]);
  };

  const handleUpdateListBook = (key, val, fieldName) => {
    const newBook = bookList?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
          d.sellQty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
          d.sellQty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = val;
        if (key === d.key && fieldName === "sellQty") d.sellQty = val;
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleDeleteListBook = (key) => {
    const handleDeleteList = bookList?.filter((d) => d.key !== key);
    setBookList([...handleDeleteList]);
  };

  const [updateStudentBook] = useMutation(UPADATE_STUDENT_BOOK, {
    onCompleted: ({ updateStudentBook }) => {
      setLoading(false);
      if (updateStudentBook?.status) {
        setAlert(true, "success", updateStudentBook?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateStudentBook?.message);
        console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error?.message);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required("require!"),
    studentId: Yup.string().required("require!"),
    enrollmentId: Yup.string().required("require!"),
    warehouseId: Yup.string().required("require!"),
    remark: Yup.string(),
    date: Yup.date().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      studentId: "",
      enrollmentId: "",
      warehouseId: "",
      remark: "",
      date: new Date(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        bookList?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty >= 0 &&
            elem?.sellQty >= 0 &&
            elem?.qty + elem?.sellQty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listProvideBookToSubmit = bookList?.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
            sellQty: parseFloat(d?.sellQty),
          };
        });
        setLoading(true);

        // console.log("values::", values, listProvideBookToSubmit);

        updateStudentBook({
          variables: {
            id: editData?._id,
            input: {
              academicYearId: values?.academicYearId,
              studentId: values?.studentId,
              enrollmentId: values?.enrollmentId,
              warehouseId: values?.warehouseId,
              provideBooks: listProvideBookToSubmit,
              remark: values?.remark,
              date: values?.date,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    values,
    setFieldValue,
  } = formik;

  // console.log("values::", values);
  // console.log("editData::", editData);

  useEffect(() => {
    if (editData) {
      // console.log("editData::", editData);
      // 
      setAcademicVal({
        id: editData?.academicYearId?._id,
        title: editData?.academicYearId?.academicYear,
      });
      setFieldValue("academicYearId", editData?.academicYearId?._id);

      setStudentVal({
        id: editData?.studentId?._id,
        title: editData?.studentId?.englishName,
      });
      setFieldValue("studentId", editData?.studentId?._id);
 
      setEnrollmentVal({ 
        id: editData?.enrollmentId?._id,
        title: editData?.enrollmentId?.classId?.gradeId?.gradeName+ " " + editData?.enrollmentId?.classId?.className,
        gradeId: editData?.enrollmentId?.classId?.gradeId?._id,
        gradeName: editData?.enrollmentId?.classId?.gradeId?.gradeName,
      });
      setFieldValue("enrollmentId", editData?.enrollmentId?._id);

      setWarehouseVal({
        id: editData?.warehouseId?._id,
        title: editData?.warehouseId?.warehouseName,
      });
      setFieldValue("warehouseId", editData?.warehouseId?._id);

      setFieldValue("date", new Date(editData?.date));
      setFieldValue("remark", editData?.remark ? editData?.remark : "");

      const newBookData = editData?.provideBooks?.map((book) => ({
        key: Date.now() + Math.random(),
        materialId: {
          id: book?.listMaterialUnitId?.materialId?._id,
          title: book?.listMaterialUnitId?.materialId?.materialEnName,
          // title: "ISBN: "+book?.listMaterialUnitId?.materialId?.isbm+" - "+ editData?.enrollmentId?.classId?.gradeId?.gradeName,
          fullName: book?.listMaterialUnitId?.materialId?.materialEnName,
        },
        listMaterialUnitId: {
          id: book?.listMaterialUnitId?._id,
          title: book?.listMaterialUnitId?.unitId?.unitKhName,
          imageSrc: book?.listMaterialUnitId?.imageSrc,
        },
        qty: book?.qty,
        sellQty: book?.sellQty,
      }));
      setBookList(newBookData);
    }
  }, [editData, open]);


  // 
  const [enrollmentData,setEnrollmentData] = useState([]);
  useEffect( () => {
    if(editData) {
      let arrayFilter = [];      
      editData?.enrollmentId?.invoices?.map( (e) => {
          // 
          e?.additionalFee?.map( (rowFee) => {
              // console.log(rowFee?.incomeHead?.incomeType);
              if(rowFee?.incomeHead?.incomeType === "AdminFee") {
                arrayFilter.push(rowFee);
              }
          })
      })  
      setEnrollmentData(arrayFilter);     
    } else {
      setEnrollmentData([])
    }
  },[enrollmentVal?.gradeName , open])
  // console.log("enrollmentData:::", enrollmentData);


  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">កែប្រែសៀវភៅសិស្ស</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំង</Typography>
                <SelectWarehouse
                  selectedVal={warehouseVal}
                  setSelectedVal={setWarehouseVal}
                  dialogTitle={dialogTitle}
                  disabled={true}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicVal}
                  setSelectedVal={setAcademicVal}
                  disabled={true}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>


              <Grid item xs={4}>
                <Typography className="field-title">កាលបរិច្ចេទ</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat="dd-MM-yyyy"
                    mask="__.__.____"
                    value={values?.date}
                    onChange={(newValue) => {
                      setFieldValue("date", newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>


              <Grid item xs={4}>
                <Typography className="field-title">ឈ្មោះសិស្ស</Typography>
                <SelectStudent
                  selectedVal={studentVal}
                  setSelectedVal={setStudentVal}
                  disabled={true}
                />
                {!!errors.studentId && touched.studentId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.studentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ថ្នាក់</Typography>
                <SelectEnrollByStudent
                  setSelectedVal={setEnrollmentVal}
                  selectedVal={enrollmentVal}
                  academicId={academicVal?.id}
                  studentId={studentVal?.id}
                  disabled={true}
                />
                {!!errors.enrollmentId && touched.enrollmentId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.enrollmentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">
                  ថ្លៃរដ្ឋបាល
                </Typography> 
                {
                  enrollmentData?.length > 0 ? (
                    <>
                      {enrollmentData?.length > 0 ? (
                        <Typography sx={{ mt: 1, color: "green" }}>
                          បានបង់ ៖ {" "}
                          { 
                            enrollmentData?.map( (row) => ( 
                              "$ "+ row?.total  
                            ))
                          }
                        </Typography>
                      ) : (
                        <Typography sx={{ mt: 1, color: "red" }}>
                          មិនបានបង់
                        </Typography>
                      )} 
                    </>
                  ) : (
                    <>
                      <Typography sx={{ mt: 1, color: "red" }}>
                        $ 0
                      </Typography>
                    </>
                  )
                }                 
              </Grid>
              
              <Grid item xs={12}>
                <ListBook
                  handleDeleteList={handleDeleteListBook}
                  handleUpdateList={handleUpdateListBook}
                  handleAddList={handleAddListBook}
                  warehouseId={warehouseVal?.id}
                  requiredField={requiredField}
                  bookList={bookList}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
